// extracted by mini-css-extract-plugin
export default {"button":"Button_button__iEiBG","primary":"Button_primary__VIPCG","secondary":"Button_secondary__zlSfz","danger":"Button_danger__fX46X"};